/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type VerifyResetKeyInput = {|
  key: string,
  clientMutationId?: ?string,
|};
export type verifyResetKeyMutationVariables = {|
  input: VerifyResetKeyInput
|};
export type verifyResetKeyMutationResponse = {|
  +verifyResetKey: ?{|
    +isKeyValid: ?boolean
  |}
|};
export type verifyResetKeyMutation = {|
  variables: verifyResetKeyMutationVariables,
  response: verifyResetKeyMutationResponse,
|};
*/


/*
mutation verifyResetKeyMutation(
  $input: VerifyResetKeyInput!
) {
  verifyResetKey(input: $input) {
    isKeyValid
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "VerifyResetKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyResetKeyPayload",
    "kind": "LinkedField",
    "name": "verifyResetKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isKeyValid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "verifyResetKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "verifyResetKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "verifyResetKeyMutation",
    "operationKind": "mutation",
    "text": "mutation verifyResetKeyMutation(\n  $input: VerifyResetKeyInput!\n) {\n  verifyResetKey(input: $input) {\n    isKeyValid\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a656de6bc13f7f0da631c86dcc7ff3db';

module.exports = node;
